<template>
   <div class="container-fluid bg-light-purple chart-gallery-overview">
      <div class="content">
         <div class="row">
            <div id="mainContainer" class="col-12 main-container">
               <div class="content-container">
                  <div id="datvizneed" class="row">
                     <div class="col-12">
                        <h1>{{ overviewData.content[1].header }}</h1>
                        <div v-html="markedRender(overviewData.content[1].longDescription)" />
                        <div id="gallery-block" class="card-deck card-deck-special mb-5">
                           <div
                              v-for="(item, index) in overviewData.content[1].body"
                              :key="index"
                              class="card"
                           >
                              <div class="card-content">
                                 <div class="card-header pb-1">
                                    <i class="icon-circle" :class="item.icon" />
                                 </div>
                                 <div class="card-body pt-0 pb-0">
                                    <h2
                                       v-if="item.header"
                                       class="mb-1 card-title bold text-secondary"
                                    >
                                       {{ item.header }}
                                    </h2>
                                    <p v-if="item.description" class="card-text">
                                       {{ item.description }}
                                    </p>
                                 </div>
                                 <div class="card-footer">
                                    <a
                                       :href="`#${getIdFromHeader(item.ctas[0].link)}`"
                                       class="btn btn-sm btn-outline-secondary"
                                       @click.prevent="btnAction(item)"
                                    >
                                       {{ item.ctas[0].header }}
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-12" data-spy="scroll" data-target="#gallery-block">
                        <Gallery :gallery="gallery" :shortdesc="descriptionJoiner(getShortDesc)" />
                     </div>
                  </div>
                  <div class="row">
                     <div class="col-12 card p-2 text-center m-1 card-destxt">
                        The demo charts on the FusionCharts website are provided for illustrative
                        purposes only.
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import { mapState } from 'vuex';
import Gallery from '../../components/playground/Gallery';
import metaGenerator from '../../util/meta.js';

export default {
   name: 'Overview',
   components: {
      Gallery,
   },
   data() {
      return {
         ...(process.browser && { chartGalleryTracker: this.$tracker.chartGallery }),
      };
   },
   computed: {
      gallery() {
         const { body } = this.overviewData.content[0];

         const makeSlug = text => {
            const firstSpace = text.indexOf(' ');
            const splicedText = text.slice(0, firstSpace);
            return splicedText.toLowerCase();
         };

         const galleryData = [];
         body.forEach(item => {
            const tab = {
               title: item.header,
               id: item.id,
               slug: makeSlug(item.header),
               items: [],
               description: item.description,
            };
            const { customBody } = item;

            if (customBody) {
               customBody.forEach(i => {
                  const data = {
                     title: i.header,
                     subtitle: i.description,
                     image: i.vectorSource.file.url,
                     onclick: i.url,
                  };
                  tab.items.push(data);
               });
            }

            galleryData.push(tab);
         });
         return galleryData;
      },
      ...mapState(['overviewData']),
      getShortDesc() {
         const data = this.overviewData;
         return (
            data.content &&
            data.content[0] &&
            data.content[0].shortDescription &&
            data.content[0].shortDescription[0]
         );
      },
   },
   asyncData({ store }) {
      return Promise.all([store.dispatch('OVERVIEW_PAGE_DATA_FETCH')]);
   },
   mounted() {
      this.$store.commit('SET_SIDEBAR_FLAG', {
         data: true,
      });

      if (this.$route.hash) {
         this.$nextTick(() => {
            this.scrollToSection(this.$route.hash.replace(/[#]/g, ''));
         });
      }
      this.chartGalleryTracker.visited();
   },
   methods: {
      btnAction(item) {
         const id = this.getIdFromHeader(item.ctas[0].link);
         this.$router.replace({ hash: id });
         this.scrollToSection(id);
      },

      scrollToSection(id) {
         const currentPos = document.documentElement.scrollTop;
         const elem = document.getElementById(id);
         const bodyRect = document.body.getBoundingClientRect();
         const elemRect = elem.getBoundingClientRect();
         const goingTo = elemRect.top - bodyRect.top;

         const travelTime =
            Math.abs(currentPos - goingTo) > 1200
               ? 1000
               : (Math.abs(currentPos - goingTo) * 1000) / 1200;

         fusionDesign.scroll.to(goingTo - 100, Math.round(travelTime), 'easeInOutExpo');
      },

      getIdFromHeader(header) {
         return header;
      },
   },
   metaInfo() {
      return metaGenerator(this.overviewData);
   },

   // DO NOT KNOW purpose of this code snippets
   /* beforeRouteUpdate(to, from, next) {
      next();

      if (this.routeProp) {
         this.$store.commit('SET_ROUTE_PROP');
         return;
      }

      this.scrollToSection();
   }, */
};
</script>

<style lang="scss" scoped>
@import '../../util';
.chart-gallery-overview {
   height: 100%;
}

.content {
   padding: 30px 0;

   @include media-breakpoint-up(sm) {
      padding: 30px;
   }

   @include media-breakpoint-up(md) {
      padding: 50px 30px 30px 30px;
   }
   @include media-breakpoint-up(lg) {
      padding: 50px 30px 50px 30px;
   }
}

.icon-circle {
   width: 40px;
   height: 40px;
   border: 1px solid rgba(105, 87, 218, 0.06);
   padding: 9px;
   border-radius: 50%;
   font-size: 25px;
}

.icon-circle:before {
   background: linear-gradient(134.72deg, #bb88fd 0%, #6957da 100%);
   -webkit-background-clip: text;
   -webkit-text-fill-color: transparent;
}

#gallery-block .card .card-footer .btn {
   min-width: auto;
}

#gallery-block .card {
   flex: 0 0 auto;
   min-width: 100%;
   max-width: 100%;
   margin: 0;
   background: transparent;
   padding: 15px 0;
   .card-content {
      height: 100%;
      background: #fff;
      border-radius: 5px;
      box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05) !important;
      display: flex;
      justify-content: center;
      flex-direction: column;

      .card-title {
         font-size: 1.6rem;
      }
   }
   @include media-breakpoint-up(sm) {
      flex: 0 0 auto;
      min-width: 50%;
      max-width: 50%;
      padding: 15px;
   }

   @include media-breakpoint-up(md) {
      flex: 0 0 auto;
      min-width: 25%;
      max-width: 25%;
   }
   @include media-breakpoint-up(lg) {
      flex: 0 0 auto;
      min-width: 50%;
      max-width: 50%;
   }

   @include media-breakpoint-up(xl) {
      flex: 0 0 auto;
      min-width: 25%;
      max-width: 25%;
   }
}
.card-destxt {
   box-shadow: 0 6px 14px 0 rgba(33, 35, 68, 0.05) !important;
}
</style>
